// Shared "should this user get new-user onboarding?" check.
//
// Used by OnboardingOverlay (to start/stop the overlay) and DesktopPetHost
// (to hold the first-run pet picker until onboarding has been completed or
// skipped, so pet selection acts as the closing step of onboarding instead
// of racing ahead of it).
const ONBOARDING_MAX_ACCOUNT_AGE_MS = 7 * 24 * 60 * 60 * 1000;

export function isEligibleForOnboarding(user, conversationCount = 0) {
  if (!user?.id) return false;
  // Ghost (anonymous) accounts haven't really signed up yet.
  if (user.flags?.isGhost) return false;
  if (user.tracking?.completedOnboardingAt) return false;

  const createdDate = user.createdAt ? new Date(user.createdAt) : null;
  // Missing createdAt ⇒ treat as an existing account, not a fresh signup.
  const isOldUser = createdDate
    ? (Date.now() - createdDate.getTime()) > ONBOARDING_MAX_ACCOUNT_AGE_MS
    : true;
  if (isOldUser) return false;

  // Users who already have conversations (local store or server stats) have
  // used the product — don't interrupt them with new-user onboarding.
  const hasExistingConversations =
    conversationCount > 0 || (user.stats?.total_conversation_count || 0) > 0;
  if (hasExistingConversations) return false;

  return true;
}
